// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1u30n","ranges":"BmiRanges_ranges__3W6u9"};